import Swal from "sweetalert2";

export const validateSession = async (response) => {
  if ("error" in response) {
      Swal.fire({
          title: `Invalid session or expired`,
          text: "Please, login again.",
          icon: 'warning',
          confirmButtonColor: '#14398a',
          cancelButtonColor: '#626262',
          showCancelButton: true,
          confirmButtonText: 'Yes, Login again.',
          cancelButtonText: 'No, cancel.',
      }).then(async (result) => {
          if (result.isConfirmed) {
              window.location.assign("/logout");
          }
      })
  }
}